import React from "react";
import Button from "@mui/material/Button";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import MenuIcon from "@mui/icons-material/Menu";
import s from "./Header.module.scss";
import HeaderMenu from "./header-menu/HeaderMenu";

const Header = ({ sidebarHandling }) => {
  const { isCollapse, handleSidebarCollapse } = sidebarHandling;

  return (
    <div className={s.headerContainer}>
      <div>
        {isCollapse && (
          <Button
            sx={{ minWidth: 32, maxWidth: 32, minHeight: 32, maxHeight: 32 }}
            className={s.collapseBtn}
            onClick={handleSidebarCollapse}
          >
            <MenuIcon sx={{ color: "#309EA7" }} />
          </Button>
        )}
        {!isCollapse && (
          <Button
            sx={{ minWidth: 32, maxWidth: 32, minHeight: 32, maxHeight: 32 }}
            className={s.collapseBtn}
            onClick={handleSidebarCollapse}
          >
            <MenuOpenIcon sx={{ color: "#309EA7" }} />
          </Button>
        )}
      </div>
      <div className={s.headerMenu}>
        <HeaderMenu />
      </div>
    </div>
  );
};

export default React.memo(Header);
